var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliderArrow = function SvgSliderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 40.95 0 20.55 20.4.05l1.6 1.6-18.8 18.9L22 39.35z"
  })));
};
export default SvgSliderArrow;